import { Select as SelectMantine } from '@mantine/core'
import styled, { createGlobalStyle } from 'styled-components'

export const Img = styled.img`
  transition: ease-in 200ms;
  transform: ${({ isOpen, isClear }) => isOpen && !isClear && 'rotate(180deg)'};
  cursor: pointer;
`

export const TextItem = styled.div`
  color: ${({ theme }) => theme.cor9} !important;
  background-color: transparent !important;
  font-size: 16px !important;
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  max-width: 99% !important;
`

export const Select = styled(SelectMantine)`
  .mantine-Select-input {
    border: none !important;
    color: ${({ theme }) => theme.cor9}!important;
    background-color: ${({ theme }) => theme.cor27}!important;
    height: 38px;
    font-size: 16px;
    line-height: 3rem;

    ::placeholder {
      color: ${({ theme }) => theme.cor70}!important;
      font-weight: 400 !important;
    }
  }

  .mantine-Select-input[data-invalid] {
    border: 0.0625rem solid ${({ theme }) => theme.inputBorderError} !important;
  }

  .mantine-Input-wrapper {
    width: ${({ width }) => width && `${width} !important`};
  }

  .mantine-Input-rightSection {
    margin-right: 8px;
    pointer-events: auto;
  }

  .mantine-Select-label {
    color: ${({ theme }) => theme.cor9} !important;
    font-size: ${({ fontSize }) => fontSize} !important;
    background-color: transparent !important;
  }
`

export const RightSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const GlobalStyles = createGlobalStyle`
    max-width: ${({ width }) => width || '100%'} !important;

  .mantine-Select-dropdown {
    background-color: ${({ theme }) => theme.cor27} !important;
    border:none !important;
  }

  .mantine-Select-item {
    border: none !important;
    background-color: transparent !important;

    :hover {
      background-color: ${({ theme }) => theme.cor57} !important;
    }
  }

  .mantine-Select-item[data-selected]  {
    background-color: ${({ theme }) => theme.cor57}!important;
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  gap: 5px;
`

export const Required = styled.div`
  color: ${({ theme }) => theme.inputBorderError};
`

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: ${({ theme }) => theme.cor9};
  font-size: 14px;
`
